import * as React from 'react';

// Material-UI
import { createTheme, ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import Box from '@mui/material/Box';

// Routing
import { Outlet } from 'react-router-dom';

// OBVM Components
import Header from '../components/header';
import Footer from '../components/footer';

const headerHeight = 50;

let theme = createTheme({
	palette: {
		primary: {
			light: '#D8D7D6',
			main: '#B1282E',
			dark: '#0F1820',
		},
	},
	typography: {
		h5: {
			fontWeight: 50,
			fontSize: 26,
			letterSpacing: 0.5,
		},
	},
	shape: {
		borderRadius: 8,
	},
	mixins: {
		toolbar: {
			height: headerHeight,
		},
	},
});

export default function HeaderBase() {
	return (
		<ThemeProvider theme={theme}>
			<Header title="Online Battery Validation Manager" drawerIcon={false} onDrawerToggle={() => {}} />
			<Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', height: `calc(100vh - ${theme.mixins.toolbar.height}px)` }}>
				<CssBaseline />
				<Box component="main" sx={{ flex: 1, py: 2, px: 2, bgcolor: '#D8D7D6' }}>
					<Box
						sx={{
							borderRadius: 1,
							bgcolor: '#FFFFFF',
							padding: 1,
							boxShadow: 10,
							height: '100%',
						}}
					>
						<Outlet />
					</Box>
				</Box>
				<Footer />
			</Box>
		</ThemeProvider>
	);
}
